/* eslint-disable no-shadow */
export enum EFFECTS_TYPES {
  RIPPLE = 'RIPPLE',
  SPARKLE = 'SPARKLE',
  COMET = 'COMET',
  CASCADE = 'CASCADE',
  MARQUEE = 'MARQUEE'
}

export enum EFFECTS_STATUS {
  WAITINGFORREVIEW = 1,
  APPROVED = 2,
  DENIED = 3
}
